export const RecycleSvg = () => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 1.66536C13.1315 1.66536 12.8333 1.9639 12.8333 2.33203V3.00103C11.5954 1.3541 9.63229 0.332031 7.49995 0.332031C4.36522 0.332031 1.69135 2.4645 0.998019 5.51756C0.916619 5.87663 1.14189 6.23403 1.50062 6.31543C1.55075 6.32683 1.60022 6.33203 1.64902 6.33203C1.95309 6.33203 2.22842 6.12236 2.29875 5.81316C2.85282 3.3711 4.99215 1.66536 7.49995 1.66536C9.42302 1.66536 11.1677 2.70903 12.1095 4.33203H10.8333C10.4648 4.33203 10.1666 4.63056 10.1666 4.9987C10.1666 5.36683 10.4648 5.66536 10.8333 5.66536H13.5C13.8684 5.66536 14.1666 5.36683 14.1666 4.9987V2.33203C14.1666 1.9639 13.8684 1.66536 13.5 1.66536Z"
        fill="currentColor"
      />
      <path
        d="M1.49998 12.3315C1.86845 12.3315 2.16665 12.033 2.16665 11.6648V10.9814C3.41118 12.6548 5.35878 13.6648 7.49998 13.6648C10.6347 13.6648 13.3086 11.5324 14.0019 8.4793C14.0833 8.12023 13.858 7.76283 13.4993 7.68143C13.1367 7.59777 12.7825 7.82463 12.7011 8.1837C12.1471 10.6258 10.0078 12.3315 7.49998 12.3315C5.57625 12.3315 3.84798 11.3132 2.89458 9.66483H4.16665C4.53511 9.66483 4.83331 9.3663 4.83331 8.99817C4.83331 8.63003 4.53511 8.3315 4.16665 8.3315H1.49998C1.13151 8.3315 0.833313 8.63003 0.833313 8.99817V11.6648C0.833313 12.033 1.13151 12.3315 1.49998 12.3315Z"
        fill="currentColor"
      />
    </svg>
  );
};
